export default {
  template: "#vue-product-availability",
  delimiters: ['${', '}'],
  props: ['item'],
  data: function () {
    return {}
  },
  computed: {
    loading() {
      return this.$store.state.product_availability === null || this.$store.getters.closest_stores === null;
    },
    pickup() {
      return this.$store.getters.get_pickup_stores(this.upc_availability)
    },
    closest_three() {
      return this.pickup.slice(0, 3)
    },
    upc_availability() {
      return this.$store.state.product_availability.variants[parseInt(this.item.sku)] || {}
    }
  },
  methods: {
    pickupAtStore(store_number) {
      this.$store.state.global_components.product.addToCart(null, store_number)
    },
    openPickupModal() {
      this.$store.state.global_components.overlay.openModal({
        modal: 'pickup',
        stores: this.$store.getters.get_pickup_stores(this.upc_availability),
        item: this.item
      });
    }
  }
}